import { Component, OnInit, Input, inject } from '@angular/core';
import { SuggestionEngineService } from '../../../suggestion-engine/suggestion-engine.service';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  imports: [MatCardModule, CommonModule],
})
export class MessagesComponent implements OnInit {
  private ses = inject(SuggestionEngineService);

  @Input() message;
  state: string = 'loaded';

  ngOnInit() {}
}
